import { z } from 'zod';

export const step3Schema = z.object({
  observacoes_finais: z.string().optional(),
  data_contrato: z.string().optional(),
  nome_verificador: z.string().optional(),
  email_verificador: z.string().email('Email inválido').optional(),
});

export type Step3Data = z.infer<typeof step3Schema>;
